import { GET_INVITED_USERS, GET_INVITED_USERS_LOADER, INVITE_USER_LOADER, LOGIN_LOADER } from '../action/auth';

const initialState = {
  loginLoader: false,
  invitedUsersData: [],
  invitedUserLoader: false,
  inviteuserloader: false,
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_LOADER:
      return {
        ...state,
        loginLoader: action.payload,
      };
    case INVITE_USER_LOADER:
      return {
        ...state,
        inviteuserloader: action.payload,
      };
    case GET_INVITED_USERS_LOADER:
      return {
        ...state,
        invitedUserLoader: action.payload,
      };

    case GET_INVITED_USERS:
      return {
        ...state,
        invitedUsersData: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default ContentReducer;
